<template>
  <h1>hola</h1>
</template>


<script>
  export default {
    mounted() {
      console.log('Component mounted.');
    }
  }
</script>
<style lang="scss">
</style>
